var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrancais(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1766_3555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 19.8619H0.413996C0.18548 19.8619 0.000183105 19.6766 0.000183105 19.4481V4.55151C0.000183105 4.32299 0.18548 4.1377 0.413996 4.1377H8.0002V19.8619Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9681 4.17017V19.8293H8.03259V4.17017H15.9681Z",
    stroke: "#878787",
    strokeWidth: 0.0646926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5864 19.8618H16.0002V4.1377H23.5864C23.8149 4.1377 24.0002 4.32299 24.0002 4.55151V19.4481C24.0002 19.6766 23.8149 19.8618 23.5864 19.8618Z",
    fill: "#FF4B55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1766_3555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrancais);
export default __webpack_public_path__ + "static/media/francais.9d555ae4a477320e8539b61e8346b833.svg";
export { ForwardRef as ReactComponent };